<template>
    <v-content class="pa-0">
        <!-- Page one -->
        <v-layout justify-start>
            <v-flex pt-5 pa-0>
                <Appbar style="padding-left: 0px"></Appbar>
            </v-flex>
        </v-layout>
        <v-container>
            <v-layout row justify-center align-center style="min-height: 250px">
                <v-flex mt-5 class="col-12 py-0">
                    <h1 style="text-align: center;font-size: 2.375rem;">Players get paid</h1>
                </v-flex>
                <v-flex class="col-sm-8 col-lg-9 col-xl-6 col-12 py-0" justify-center>
                    <p class="mb-5 px-12" style="text-align: center;font-size: 1.1rem">Make every day payday. With Storm’s apps you can complete quick microtasks to earn Storm, Bitcoin, Ethereum, Litecoin, or Dai. Seriously, it’s that simple.</p>
                    <v-flex justify-center class="col-12 mt-4" style="display: flex;flex-wrap: wrap">
                        <v-btn class="mr-1 mt-1 pa-0" :class="{'mb-5' : $vuetify.breakpoint.xs}"  style="border-radius: unset;box-shadow: none"><img  :src="require('../assets/cta-appstore.svg')"></v-btn>
                        <v-btn class="mt-1 pa-0" style="border-radius: unset;box-shadow: none"><img  :src="require('../assets/cta-google-play.svg')"></v-btn>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
        <img style="width: 100%;margin-top: 1rem" :src="require('../assets/hero.jpg')">
        <v-container style="padding-bottom: 0px">
            <v-layout row style="min-height: 500px" :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                <v-flex offset-xl2 xl4 :class="{'col-10': $vuetify.breakpoint.smAndDown}" justify-center class="col-6" style="display: flex;padding-bottom: 0px">
                    <img style="width: 100%" :src="require('../assets/showcase-ios.png')">
                </v-flex>
                <v-flex offset-xl1 xl3 class="col-5" :class="{'col-10': $vuetify.breakpoint.smAndDown,'pt-12' : $vuetify.breakpoint.smAndDown}">
                    <h3 style="font-size: 1.75rem;margin-bottom: 1.2rem">A gig has never been this easy</h3>
                    <p style="font-size: 1rem">Instead of taking surveys on social media that tell you which 90s sitcom character you are, get paid for your downtime by completing surveys in the StormX app.</p>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container style="padding-bottom: 0px">
            <v-layout row style="min-height: 500px" :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                <v-flex  offset-xl2 xl3 class="col-6" :class="{'col-10': $vuetify.breakpoint.smAndDown}">
                    <h3 style="font-size: 1.75rem;margin-bottom: 1.2rem;margin-top: 2.5rem">Play games you always win</h3>
                    <p style="font-size: 1.125rem;font-weight: 400;padding-bottom: 1.5rem!important;">You like trying new products and playing games. But you love getting paid for your time. Turn something you like into something you love with the StormX app.</p>
                </v-flex>
                <v-flex xl4 justify-center :class="{'col-10': $vuetify.breakpoint.smAndDown}" class="col-6" style="display: flex;padding-bottom: 0px">
                    <img style="width: 100%" :src="require('../assets/showcase-android.png')">
                </v-flex>
            </v-layout>
        </v-container>
        <v-img style="width: 100%;margin-top: 1rem"  :src="require('../assets/angle-top.svg')"></v-img>
        <v-layout style="width: 100%;background-color: whitesmoke" class="ma-0 pa-0">
            <v-container pa-0>
                <v-layout class="ma-0 pa-0" row style="min-height: 500px" :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                    <v-flex offset-xl2 xl4 :class="{'col-10': $vuetify.breakpoint.smAndDown}" justify-center class="col-5" style="background-color: #f6f7f7;display: flex;padding-bottom: 0px">
                        <img style="width: 500px;height: 500px" :src="require('../assets/logo-cloud.svg')">
                    </v-flex>
                    <v-flex offset-xl1 xl3 class="offset-md1 col-5" style="padding-top: 23rem;padding-bottom: 8rem" :class="{'col-10': $vuetify.breakpoint.smAndDown}">
                        <h3 style="font-size: 1.75rem;margin-bottom: 1.2rem">Complete tasks. Get crypto</h3>
                        <p style="font-size: 1.125rem;font-weight: 400;padding-bottom: 1.5rem!important;">Join the millions of Players who’ve been rewarded over 13 million Storm Tokens, 249 Bitcoins, and 570 Ethereum since 2014. Be a part of the new gig economy and get paid when you want.</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
        <v-img style="width: 100%;margin-top: unset" :src="require('../assets/angle-bottom.svg')"></v-img>
    </v-content>
</template>

<script>
    import Appbar from "../components/Appbar"
    export default {
        name: "Players",
        components: {
            Appbar,
        },
    }
</script>

<style scoped>

</style>
